import { updateWindowScreenObjectsWithoutRender } from "../../Redux/Actions/FormStateActions";
import { formStateStore } from "../../Redux/Store/store";

export const deepCompareJson = (arg1, arg2) => {
  if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)){
    if (Object.prototype.toString.call(arg1) === '[object Object]' || Object.prototype.toString.call(arg1) === '[object Array]' ){
      if (Object.keys(arg1).length !== Object.keys(arg2).length ){
        return false;
      }
      return (Object.keys(arg1).every(function(key){
        return deepCompareJson(arg1[key],arg2[key]);
      }));
    }
    return (arg1===arg2);
  }
  return false;
}


export const getRecursiveParent = (currentElementId) => {
  let pointer = currentElementId;
  let pointerElemType = document.getElementById(pointer)?.getAttribute('elem_type');
  let familyPath = pointer;
  let familyPathElemType = pointerElemType;
  let pointerForElem=currentElementId;

  try{
    while(pointer!=='RootControl'){
      if(
        document.getElementById(pointer).parentElement!==null
        &&
        document.getElementById(pointer).parentElement!==undefined
      ){
        var currId = pointer;
        var currElem;
        currId = document.getElementById(pointer).parentElement.getAttribute('id');
        currElem = document.getElementById(pointer).parentElement.getAttribute('elem_type');
        if(currId===null || currId===undefined){
          currId = document.getElementById(pointer).parentElement.getAttribute('control_id');
          if(currElem===null || currElem===undefined){
            currElem = document.getElementById(pointer).parentElement.getAttribute('elem_type');
          }
        }
        let parentNode;
        if(currId!==null && currId!==undefined){
          parentNode = document.getElementById(currId).parentElement;
        } else {
          parentNode = document.getElementById(pointer).parentElement;
        }
        while((currId===null || currId===undefined) && (currElem===null || currElem===undefined)){
          currId = parentNode.parentElement.getAttribute('id');
          currElem = parentNode.parentElement.getAttribute('elem_type');
          if((currId===null || currId===undefined) && (currElem===null || currElem===undefined)){
            parentNode = parentNode.parentElement;
          }
        }
        pointer = currId;
        pointerElemType = currElem;
        pointerForElem = pointerElemType;

        if(pointer!==null && pointer!==undefined){
          familyPath = pointer +'|'+ familyPath;
        }
        if(pointerElemType!==null && pointerElemType!==undefined){
          familyPathElemType = pointerElemType +'_'+ familyPathElemType;
        }

      }
    }
  } catch(e) {
     console.log('Error :: ',e);
  }
  return {
    'familyPath' : familyPath,
    'familyPathElemType' : familyPathElemType,
  };
}

export const checkForAllowedFormStructure = (doppingElemType , insideElemTypes) => {
  let allowed = true;
  if(insideElemTypes!==null || insideElemTypes!==undefined){

    //section
    let sectionNotAllowedIn = [
      'form_frame',
      'form_frame_section_row',
      'form_frame_section_row_column',
      'form_frame_section_row_column_tab_sheet_tabChild_frame',
      'form_frame_section_row_column_tab_sheet_tabChild_frame_section_row',
      'form_frame_section_row_column_tab_sheet_tabChild_frame_section_row_column',
      'form_tab_sheet_tabChild_frame',
      'form_tab_sheet_tabChild_frame_section',
      'form_tab_sheet_tabChild_frame_section_row',
      'form_tab_sheet_tabChild_frame_section_row_column',
      'form_tab_sheet_tabChild_row_column', //confirm for allowed
    //for sidenavigation make more cases
    // for wizard make more cases
    ];

    //tab
    let tabNotAllowedIn = [
      'form_tab_sheet_tabChild_frame',
      'form_tab_sheet_tabChild_frame_section_row',
      'form_tab_sheet_tabChild_frame_section_row_column',
      'form_frame_section_row_column_tab_sheet_tabChild_frame_section',
      'form_frame_section_row_column_tab_sheet_tabChild_frame_section_row',
      'form_frame_section_row_column_tab_sheet_tabChild_frame_section_row_column',
    ];

    //sidenavigation
    let sideNavigationNotAllowedIn = [
      'form_tab_sheet_tabChild_frame',
      'form_tab_sheet_tabChild_frame_section_row',
      'form_tab_sheet_tabChild_frame_section_row_column'
    ];

    let textboxNotAllowedIn = [
      'RootControl',
    ];


    if((doppingElemType==='section' || doppingElemType==='frame' || doppingElemType==='headerframe') && sectionNotAllowedIn.includes(insideElemTypes)){
        allowed = false;
    }
    if((doppingElemType==='tab') && tabNotAllowedIn.includes(insideElemTypes)){
        allowed = false;
    }
    if((doppingElemType==='sidenavigation') && sideNavigationNotAllowedIn.includes(insideElemTypes)){
        allowed = false;
    }
    if((doppingElemType==='textbox') && textboxNotAllowedIn.includes(insideElemTypes)){
        allowed = false;
    }
    
  }
  return allowed;
}

export const handleWinObjects = (newWin) => {
  formStateStore.dispatch(updateWindowScreenObjectsWithoutRender({ value: newWin}));
}